export default __webpack_public_path__ + "static/media/doodle.483713ff.svg";